import { useState, useEffect } from "react";
import { FaStore, FaUsers, FaTruck, FaShieldAlt } from "react-icons/fa";

const AboutUs = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="bg-bodyBgColor relative select-none">
      <div className="min-h-screen ">
        {/* Hero Section */}
        <div className="bg-gradient-to-br from-indigo-500 to-darkBgColor text-white py-10 px-5 text-center">
          <h1 className="text-4xl font-bold">About Super Store</h1>
          <p className="mt-3 text-lg">
            Your trusted multivendor marketplace in Bangladesh 🇧🇩
          </p>
        </div>

        {/* Container */}
        <div className="max-w-[1100px] mx-auto px-5 py-12 space-y-12">
          {/* Intro Card */}
          <div className="bg-white p-8 rounded-xl shadow-lg text-center">
            <h2 className="text-2xl font-semibold mb-4">Who We Are</h2>
            <p className="text-gray-700 text-base leading-relaxed">
              <b>Super Store</b> is a multivendor eCommerce platform where
              trusted sellers connect with customers across Bangladesh. We aim
              to make online shopping simple, fast, and reliable—whether you’re
              in Dhaka or outside the city.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-xl text-center shadow-md hover:shadow-xl transition">
              <FaStore className="text-indigo-500 text-3xl mx-auto mb-3" />
              <h3 className="text-xl font-semibold mb-2">Multiple Sellers</h3>
              <p className="text-gray-600 text-sm">
                Buy from verified sellers on one platform.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl text-center shadow-md hover:shadow-xl transition">
              <FaUsers className="text-indigo-500 text-3xl mx-auto mb-3" />
              <h3 className="text-xl font-semibold mb-2">Happy Customers</h3>
              <p className="text-gray-600 text-sm">
                Customer satisfaction is our top priority.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl text-center shadow-md hover:shadow-xl transition">
              <FaTruck className="text-indigo-500 text-3xl mx-auto mb-3" />
              <h3 className="text-xl font-semibold mb-2">Fast Delivery</h3>
              <p className="text-gray-600 text-sm">
                Dhaka: 1 day • Outside Dhaka: 2–3 days.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl text-center shadow-md hover:shadow-xl transition">
              <FaShieldAlt className="text-indigo-500 text-3xl mx-auto mb-3" />
              <h3 className="text-xl font-semibold mb-2">Secure Platform</h3>
              <p className="text-gray-600 text-sm">
                Safe payments & reliable order handling.
              </p>
            </div>
          </div>

          {/* Mission & Vision */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition">
              <h3 className="text-xl font-semibold mb-2">🎯 Our Mission</h3>
              <p className="text-gray-700 text-sm">
                To empower local sellers and provide customers with a smooth,
                affordable, and trustworthy online shopping experience.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition">
              <h3 className="text-xl font-semibold mb-2">🌱 Our Vision</h3>
              <p className="text-gray-700 text-sm">
                To become one of Bangladesh’s most reliable digital
                marketplaces, connecting communities through commerce.
              </p>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
            <div className="bg-gradient-to-br from-indigo-500 to-purple-500 text-white p-8 rounded-xl shadow-lg">
              <h2 className="text-3xl font-bold mb-1">500+</h2>
              <p className="text-sm">Sellers</p>
            </div>

            <div className="bg-gradient-to-br from-indigo-500 to-purple-500 text-white p-8 rounded-xl shadow-lg">
              <h2 className="text-3xl font-bold mb-1">10,000+</h2>
              <p className="text-sm">Products</p>
            </div>

            <div className="bg-gradient-to-br from-indigo-500 to-purple-500 text-white p-8 rounded-xl shadow-lg">
              <h2 className="text-3xl font-bold mb-1">50,000+</h2>
              <p className="text-sm">Customers</p>
            </div>
          </div>
        </div>
      </div>
      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="
              fixed bottom-6 right-6
              w-8 h-8 md:w-8 md:h-8
              bg-darkBgColor text-white
              rounded-full
              shadow-lg
              flex items-center justify-center
            "
        >
          ↑
        </button>
      )}
    </div>
  );
};

export default AboutUs;
